export default {
	SALARY_COMPONENT: 'Salary component',
	RULES: 'Rules',
	ACTIVE: 'Active',
	TOOLTIP: 'Add new or Update rates'
};